// extracted by mini-css-extract-plugin
module.exports = {"root":"FullScreenLoading_root__1XSoi"};